import { Tag } from 'primereact/tag';
import React, { useCallback, useEffect, useState } from 'react';

import { kanbanColorMap } from '../../../../constants';
import { Numbers } from '../../../../utils/typeConstants';
import './progressStats.scss';

interface ProgressStatsProps {
    statusNames: string[];
}
type StatusValues = {
    label: string;
    value: number;
    color: string;
};

export const ProgressStats = ({ statusNames }: ProgressStatsProps) => {
    const [statusValues, setStatusValues] = useState<StatusValues[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [complete, setComplete] = useState<number | string>(0);
    useEffect(() => {
        setStatusValues([]);
            setTotal(0);
            setComplete(0);
        if (!statusNames || statusNames?.length === 0) {
            // setStatusValues([]);
            // setTotal(0);
            // setComplete(0);
            return;
        }

        const newStatusValues = statusNames.reduce((acc, status) => {
            const newAcc = [...acc];
            const index = newAcc.findIndex((item: any) => item.label === status);
            if (index !== -1) {
                newAcc[index] = { ...newAcc[index], value: (newAcc[index].value || 0) + 1 };
            } else {
                const color = kanbanColorMap.get(status);
                newAcc.push({ label: status, value: 1, color: color || '#fff' });
            }
            return newAcc;
        }, [] as StatusValues[]);

        setStatusValues(newStatusValues);
        setTotal(statusNames.length);
        if (statusNames.includes('Done')) {
            const foundItem = newStatusValues.find((item) => item.label === 'Done');
            const val = foundItem ? foundItem.value : Numbers.ZERO;
            const perc = Math.trunc((val / statusNames.length) * Numbers.HUNDRED);
            setComplete(perc);
        }
    }, [statusNames]);

    const getTotalPercentage = useCallback(() => {
        if (total === 0) return 'transparent';
        let cumulativePercentage = 0;
        const colorStops = statusValues.map((status) => {
            const percentage = (status.value / total) * 100;
            const colorStop = `${status.color} ${cumulativePercentage}% ${
                cumulativePercentage + percentage
            }%`;
            cumulativePercentage += percentage;
            return colorStop;
        });
        return colorStops.join(', ');
    }, [statusValues]);

    return total > 0 ? (
        <div className="progressContainer">
            <h1 className="progressTaskNumber">{total}</h1>
            <div className="progressComplete">
                <Tag
                    value={`${complete}% Complete`}
                    className="statusPill w-100"
                    style={{ fontSize: '13px' }}
                />
            </div>
            <div className="progressIcon completeListIcon" />
            <h6 className="progressSubtitle">Tasks</h6>

            <div
                className="progressStatus"
                style={{
                    background: `linear-gradient(to right, ${getTotalPercentage()})`,
                }}
            />
            <div className="progressLegend">
                {statusValues.map((status, index) => (
                    <div key={index}>
                        <span className="legendDot" style={{ backgroundColor: status.color }} />{' '}
                        {status.label}
                    </div>
                ))}
            </div>
        </div>
    ) : null;
};
